import { Pipe, PipeTransform } from '@angular/core';
import { Constant } from 'src/constant';

@Pipe({
    name: 'priceFormater'
})
export class PriceFormaterPipe implements PipeTransform {

    constructor() { }

    transform(value: number, params: { language: string, currency: string }) {
        if (!params) {
            throw 'Integration error: no params provided in pipe';
        }
        if (!params.language) {
            throw 'Integration error: no language provided in pipe';
        }
        if (!params.currency) {
            throw 'Integration error: no currency provided in pipe';
        }
        const { language, currency } = params;
        const isCurrencyBeforePrice = Constant.Currencies[currency].displayBeforePrice;
        let formattedValue;

        if (language === 'en') {
            formattedValue = value.toFixed(2).replace(/[.,]00$/, '');
        } else {
            formattedValue = value.toFixed(2).replace(/[.,]00$/, '').replace('.', ',');
        }

        if (isCurrencyBeforePrice) {
            return Constant.Currencies[currency].symbol + formattedValue;
        }
        return formattedValue + ' ' + Constant.Currencies[currency].symbol;
    }
}
